if (!customElements.get('swiper-component')) {
  class SwiperComponent extends HTMLElement {
    constructor () {
      super();
      this.slider = null;
      this.initialized = false;
    }

    connectedCallback () {
      if (!this.initialized) {
        this.initSlider();
        this.initialized = true;
      }
    }

    initSlider () {
      const id = this.getAttribute('id') || 'default-slider';
      const slidesPerView = this.getAttribute('slidesPerView') || 'auto';
      const spaceBetween = parseInt(this.getAttribute('spaceBetween') || 18);
      const centeredSlides = this.getAttribute('centeredSlides') === 'true';
      const initialSlide = parseInt(this.getAttribute('initialSlide') || 0);
      const loop = this.getAttribute('loop') === 'true';
      const useNavigation = this.getAttribute('useNavigation') === 'true';
      const usePagination = this.getAttribute('usePagination') === 'true';
      const breakpoint = parseInt(this.getAttribute('breakpoint') || 750);
      const initialSlideDesktop = parseInt(this.getAttribute('initialSlideDesktop')) || null;
      const spaceBetweenDesktop = parseInt(this.getAttribute('spaceBetweenDesktop')) || null;
      const slidesPerViewDesktop = this.getAttribute('slidesPerViewDesktop') || null;
      const disableCenteredSlidesDesktop = this.getAttribute('disableCenteredSlidesDesktop') === 'true';

      this.params = null;

      try {
        let params = this.querySelector('[data-params]')?.textContent;
        if (params) {
          this.params = JSON.parse(params);
        }
      } catch (e) {
        console.log(e);
      }
      let defaultParams = {
        slidesPerView,
        spaceBetween,
        centeredSlides,
        initialSlide,
        loop,
        freeMode: false,
        navigation: useNavigation ? {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        } : false,
        pagination: usePagination ? {
          el: `#${id} .swiper-pagination`,
          clickable: true,
        } : false,
        breakpoints: {
          [breakpoint]: {
            ...(initialSlideDesktop !== null && { initialSlide: initialSlideDesktop }),
            ...(spaceBetweenDesktop !== null && { spaceBetween: spaceBetweenDesktop }),
            ...(slidesPerViewDesktop !== null && { slidesPerView: slidesPerViewDesktop }),
            ...(disableCenteredSlidesDesktop && { centeredSlides: false }),
          },
        },
      };
      if (this.params) {
        defaultParams = { ...defaultParams, ...this.params };
      }
      this.slider = new Swiper(`#${id} .swiper`, defaultParams);

      this.slider.on('slideChange', function (slide) {
        const media = slide.el.querySelector('video, iframe');
        if (media) {
          window.pauseAllMedia();
        }
      });
    }
  }

  customElements.define('swiper-component', SwiperComponent);
}
